import { apiSlice } from '../../api/apiSlice';
import { ZoneListParams, ZoneListResponse } from './zoneListApiSliceTypes';

const zoneListApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getZoneList: builder.query<ZoneListResponse, ZoneListParams>({
            query: (params) => {
                const { page = 1, limit = 10, ...queryParams } = params ?? {};

                return {
                    url: '/zones',
                    method: 'GET',
                    headers: {
                        'Accept-Language': params.acceptLanguage ?? 'en',
                    },
                    params: {
                        page,
                        limit,
                        ...queryParams,
                    },
                };
            },

            providesTags: (response) =>
                response?.data?.items
                    ? [
                          ...response.data.items.map((zone) => ({
                              type: 'zones' as const,
                              id: zone.id,
                          })),
                          { type: 'zones', id: 'LIST' },
                      ]
                    : [{ type: 'zones', id: 'LIST' }],
        }),
    }),
    overrideExisting: true,
});

export const { useGetZoneListQuery, useLazyGetZoneListQuery } =
    zoneListApiSlice;
